import Background from '../../../components/elements/sliders/sliderBackground';
import Container from '../../atoms/container/sliderContainer';
import Focus from '../../../../shared/types/enums/focus';
import List from '../list/sliderList/sliderList';
import MainContext from '../../../../shared/components/utils/context/mainContext';
import closeMenu from '../../../../shared/actions/menu/closeMenu';
import { closeFloatingMenu } from '../../../../shared/store/thunks/floatingMenu.thunk';
import { setFocus } from '../../../../shared/store/slices/focus.slice';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { useContext, useState } from 'react';
import AdUtils from '@shared/utils/ads';

/**
 * Sliders component that displays the main slider section.
 * Manages slider background, list navigation, and ad impression tracking.
 * Handles focus management and menu interactions.
 *
 * @returns {JSX.Element} The sliders container with background and list components
 */
function Sliders() {
  const dispatch = useAppDispatch();
  const { sliders } = useContext(MainContext);
  const [forcedIndex, setForcedIndex] = useState(0);

  /**
   * Handles slider index changes from the background component.
   * Sends banner focus ad impressions and updates the forced index for the list.
   *
   * @param {number} index - The new slider index
   */
  const changeIndex = (index: number) => {
    if (sliders) {
      sliders[index]?.impressions?.bannerFocus?.forEach((impression) => {
        AdUtils.sendImageImpression(impression);
      });
    }
    setForcedIndex(index);
  };
  return (
    <Container
      onMouseEnter={() => {
        dispatch(closeFloatingMenu());
        closeMenu();
        sliders?.length && dispatch(setFocus(Focus.SLIDERS));
      }}
    >
      <Background onSetBackgroundIndex={changeIndex} />
      <List forcedIndex={forcedIndex} />
    </Container>
  );
}

export default Sliders;
